import classNames from 'classnames';
import { FunctionComponent } from 'react';

import ChevronDownIcon from 'src/icons/chevron-down.svg';

import styles from './LocalePicker.module.scss';

export type LocalePickerVariant = 'primary' | 'secondary';
interface LocalePickerProps {
  variant: LocalePickerVariant;
  // TODO: Implement Locale onChange Handler. https://sim.amazon.com/issues/ASX-132
  // localeCodes: string[];
  // onChange: () => void;
}

const DEFAULT_LOCALE = 'en-US';

// TODO: Add/Review full list of P0 Locales
const LABELS_BY_LOCALE = {
  'en-US': 'English (US)',
  'es-ES': 'Español (ES)',
  'es-MX': 'Español (MX)',
  'fr-FR': 'Français (FR)',
  'fr-CA': 'Français (CA)',
  'fr-BE': 'Français (BE)',
  'it-IT': 'Italiano (IT)',
  'de-DE': 'Deutsch (DE)',
  'ja-JP': '日本語 (日本)',
  'pt-BR': 'Português (BR)',
  'pt-PT': 'Português (PT)',
  'zh-CN': '普通话 (中国)',
};

export const LocalePicker: FunctionComponent<LocalePickerProps> = ({ variant = 'primary' }) => {
  const isSecondary = variant === 'secondary';

  return (
    <div
      aria-label="locale-picker"
      className={classNames(styles.localePicker, {
        [styles.secondaryLocalePicker]: isSecondary,
      })}
    >
      <span className={classNames(styles.localeLabel, { [styles.secondaryLabel]: isSecondary })}>
        {' '}
        {LABELS_BY_LOCALE[DEFAULT_LOCALE]}{' '}
      </span>
      <span>
        <ChevronDownIcon className={classNames(styles.localePickerIcon, { [styles.secondaryIcon]: isSecondary })} />
      </span>
      {/* TODO: Implement Locale picker dropdown view and active state. https://sim.amazon.com/issues/ASX-133 */}
    </div>
  );
};
